import { Assinante } from './assinante.model';
import { AssinantePF, AssinantePJ } from '../assinante/assinante.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class AssinantesService {

    constructor(private http: Http) {

    }

    getAssinantes(): Observable<Assinante[]> {
        return this.http.get(`${NTECH_API}/assinantes`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }

    getAssinanteById(id: string): Observable<any> {
        return this.http.get(`${NTECH_API}/assinantes/${id}`)
          .map(response => response.json())
          .catch(ErrorHandler.handleError);
    }

    getAssinantePFById(id: string): Observable<AssinantePF> {
        return this.http.get(`${NTECH_API}/assinantes/${id}`)
          .map(response => response.json())
          .catch(ErrorHandler.handleError);
    }

    gravarAssinantePF(assinante: AssinantePF): Observable<AssinantePF> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');

        //if ((assinante.Id !== undefined) && ((assinante.Id.length > 0) || (assinante.Id !== '0'))) {
        if ((assinante.Id !== undefined) && (assinante.Id !== 0)) {
            return this.http.put(`${NTECH_API}/assinantes/${assinante.Id}`,
               JSON.stringify(assinante), new RequestOptions({headers: headers}))
            .map(response => response.json())
            .catch(ErrorHandler.handleError);
        } else {
            return this.http.post(`${NTECH_API}/assinantes`, JSON.stringify(assinante), new RequestOptions({headers: headers}))
            .map(response => response.json())
            .catch(ErrorHandler.handleError);
        }
    }

    gravarAssinantePJ(assinante: AssinantePJ): Observable<AssinantePJ> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');

        //if ((assinante.Id !== undefined) && ((assinante.Id.length > 0) || (assinante.Id !== '0'))) {
        if ((assinante.Id !== undefined) && (assinante.Id !== 0)) {
            return this.http.put(`${NTECH_API}/assinantes/${assinante.Id}`,
               JSON.stringify(assinante), new RequestOptions({headers: headers}))
            .map(response => response.json())
            .catch(ErrorHandler.handleError);
        } else {
            return this.http.post(`${NTECH_API}/assinantes`, JSON.stringify(assinante), new RequestOptions({headers: headers}))
            .map(response => response.json())
            .catch(ErrorHandler.handleError);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/assinantes/assinantes.service.ts